import { useMemo } from "react";

import { RigFracGroupBy } from "constants/charts.enums";
import { RIG_FRAC_CHART_GROUP_BY_ATTRIBUTE } from "constants/rigFrac.constants";
import {
  selectHeldFocusColors,
  useFocusColorHoldStore
} from "stores/focusColorHoldStore";
import {
  RigFracFocusBinsSelection,
  focusBinsFromPaint,
  resolveFocusPaint
} from "utils/color/focusColorSync";

import { useFocusColorSync } from "hooks/focusColorSync";

/**
 * The main focus bins a rig/frac chart grouped by `groupBy` maps its labels
 * onto. Read from the same focus answer, held while pending, that colours the
 * bars. Until the bar colours' /values domain loads, the bars keep the
 * server's colours.
 */
export function useRigFracFocusBins(
  groupBy: RigFracGroupBy,
  enabled: boolean
): Maybe<RigFracFocusBinsSelection> {
  const attribute = RIG_FRAC_CHART_GROUP_BY_ATTRIBUTE[groupBy];
  const resolution = useFocusColorSync({ enabled });
  const heldByAttribute = useFocusColorHoldStore(selectHeldFocusColors);
  const held = attribute ? heldByAttribute[attribute] : undefined;
  return useMemo(
    () =>
      focusBinsFromPaint(
        resolveFocusPaint({ resolution, layerAttribute: attribute, held })
      ),
    [resolution, attribute, held]
  );
}
